import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Rating, { THEMES } from '../index';
import { formatSimpleNumber } from '../../../../utils';
import useObserver from '../../hooks/useObserver';
import reportImpressionEvents from './eventsConfig';

import classes from './styles.module.scss';

/**
 * @param {string} header
 * @param {boolean} isBuyerProfile - whether it is in buyer profile
 * @param {number} ratingsCount - number of reviewers
 * @param {number} score - review's average score between 1-5
 * @param {Object} props - Orca's Rating component props
 * @returns {JSX.Element} - examples:
 * example 1: header = 'reviews', ratingsCount = 100, score = 4.5
 * returns: 100 reviews {stars} 4.5
 **/
const HeaderRating = ({ isBuyerProfile, header, ratingsCount = 0, score = 0, ...props }) => {
    const headerRatingRef = useRef(null);

    useObserver({
        observableRef: headerRatingRef,
        onObserve: () => reportImpressionEvents(score, ratingsCount),
    });

    const displayedRatingCount = ratingsCount ? <span>{formatSimpleNumber(ratingsCount)} </span> : null;

    return (
        <span
            ref={headerRatingRef}
            className={classnames(classes.headerRating, { [classes.headerRatingSpaceBetween]: isBuyerProfile })}
        >
            <span>
                {!isBuyerProfile && displayedRatingCount}
                {header}
            </span>
            {score && (
                <Rating
                    ratingsCount={isBuyerProfile ? ratingsCount : undefined}
                    score={score}
                    theme={isBuyerProfile ? THEMES.ONE_STAR : THEMES.FIVE_STARS}
                    scoreMinimumFractionDigits={1}
                    scoreMaximumFractionDigits={1}
                    {...props}
                />
            )}
        </span>
    );
};

HeaderRating.propTypes = {
    header: PropTypes.string,
    ratingsCount: PropTypes.number,
    score: PropTypes.number,
    theme: PropTypes.string,
};

export default HeaderRating;
